<template>
  <div>
    <v-container
      id="regular-tables"
      fluid
      tag="section"
    >
        <!-- :items="convocatoriaCalculadas" -->
      <v-data-table
        :headers="headers"
        :items="convocatorias"
        item-key="name"
        class="elevation-1"
        :search="search"
        :loading="loading"
      >
        <template v-slot:top>
          <v-row
            class="pa-4"
          >
            <v-col>
              <v-btn
                color="primary"
                :loading="isLoadingDownload"
                @click="exportarExcel"
              >
                Descargar data
                <v-icon> mdi-download </v-icon>
              </v-btn>
            </v-col>
            <v-col
              class="py-0 my-0"
            >
              <v-text-field
                v-model="search"
                label="Buscar convocatoria..."
                outlined
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.accions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                @click="editarConvocatoria(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip 
            v-if="isAdmin"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="dialogDelete(item)"
              >
                mdi-trash-can-outline
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="verEntidades(item)"
              >
                mdi-eye-settings
              </v-icon>
            </template>
            <span>Entidades</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-container>

    <v-menu 
        v-if="isAdmin"
        offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          right
          absolute
          dark
          fab
          v-bind="attrs"
          v-on="on"
        >
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          link
          @click="newConvocatoria"
        >
          <v-list-item-title>Agregar individual</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="isAdmin"
          link
          @click="agregarPorExcel"
        >
          <v-list-item-title>Agregar por Excel</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

  <new-convocatorias-component
    ref="newConvocatoria"
    @onCreate="onCreate"
  ></new-convocatorias-component>

  <dialog-personalizado
    ref="dialogEntidades"
    @onDialog="onDialog"
  />

  <agregar-por-excel
    ref="agregarPorExcel"
    @onUploadExcel="onUploadExcel"
  />
</div>
</template>

<script>

  import DialogPersonalizado from './../components/Dialog.vue'
  import NewConvocatoriasComponent from './components/NewConvocatoriasComponent.vue'
  import AgregarPorExcel from './components/AgregarPorExcel.vue'
  import moment from 'moment'

  import xlsx from 'json-as-xlsx'
  // import firebase from 'firebase'

  // const db = firebase.firestore()

  export default {
    components: {
      NewConvocatoriasComponent,
      DialogPersonalizado,
      AgregarPorExcel,
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Nombre', value: 'nombre' },
          { text: 'Cantidad de entidades tecnicas', value: 'cantidad_de_entidades_tecnicas' },
          { text: 'Cant.MD. Registrado', value: 'cantidad_de_modulos_registrados' },
          { text: 'Cant.MD. Licitado ', value: 'cantidad_de_modulos_licitados' },
          { text: 'Cant.MD. Ganados ', value: 'cantidad_de_modulos_ganados' },
          { text: 'Cant.MD. partic % ', value: 'porcentaje_cantidad_de_modulos_participados' },
          { text: 'Cant.MD. Eficacia % ', value: 'porcentaje_cantidad_de_modulos_eficacia' },
          { text: 'Actualizacion ', value: 'updated_at' },
          { text: 'Estado', value: 'estado' },
          // { text: 'Cantidad de entidades tecnicas', value: 'cantidadDeEntidadesTecnicas' },
          // { text: 'Cant.MD. Registrado', value: 'cantidadDeModulos' },
          // { text: 'Cant.MD. Licitado ', value: 'cantidadDeModulosLicitados' },
          // { text: 'Cant.MD. Ganados ', value: 'cantidadDeModulosGanados' },
          // { text: 'Cant.MD. partic % ', value: 'cantidadDeModulosParticipante' },
          // { text: 'Cant.MD. Eficacia % ', value: 'cantidadDeModulosEficacia' },
          { text: 'Accions', value: 'accions' },
        ],
        convocatorias: [],
        convocatoriaCalculadas: [],
        datosDeEntidades: [],
        auxiliarModulos: 0,
        auxliliarEntidadesTecnicas: 0,
        auxiliarModulosGanados: [],
        cantidadModulosGanados: 0,
        auxiliarModulosPerdidos: [],
        cantidadModulosPerdidos: 0,
        isLoadingDownload: false,
        cantidad_de_modulos_aux: 0,
        aux_modulos_ganados: 0,
        aux_modulos_perdidos: 0,
        aux_modulos_en_negociacion: 0,
        aux_entidades_ganadas: 0,
        aux_entidades_perdidas: 0
      }
    },
    computed: {
      isAdmin () {
        return JSON.parse(localStorage.userAuth).perfil !== 'Administrador' ? false : 'a'
      },
      tieneConvocatorias () {
        if (this.convocatorias) {
          return true
        } else {
          return false
        }
      }
    },
    async mounted () {
      await this.getConvocatorias()
      // await this.getEntidadesTecnicas()
    },
    methods: {
      newConvocatoria () {
        this.$refs.newConvocatoria.open()
      },
      onCreate () {
        this.getConvocatorias()
      },
      async getConvocatorias () {
        this.convocatorias = []
        this.convocatoriaCalculadas = []
        this.loading = true

        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/convocatoria')
        const data = await response.json()
        data.data.forEach(element => {
          this.cantidad_de_modulos_aux = 0
          this.aux_modulos_ganados = 0
          this.auxiliarModulosPerdidos = 0
          this.aux_modulos_en_negociacion = 0
          this.aux_entidades_ganadas = 0
          this.aux_entidades_perdidas = 0

          element.entidades_tecnicas.forEach(entidad => {
            this.cantidad_de_modulos_aux = parseInt(this.cantidad_de_modulos_aux) + parseInt(entidad.pivot.cantidad_de_modulos)
            if (entidad.pivot.gano_entidad_tecnica) {
              // this.aux_modulos_ganados++
              this.aux_modulos_ganados += parseInt(entidad.pivot.cantidad_de_modulos)
              this.aux_entidades_ganadas++
            }
            if (entidad.pivot.perdio_entidad_tecnica) {
              // this.auxiliarModulosPerdidos++
              this.auxiliarModulosPerdidos += parseInt(entidad.pivot.cantidad_de_modulos)
              this.aux_entidades_perdidas++
            }
            if (entidad.pivot.estado_de_negociacion === 'NEGOCIACIÓN') {
              this.aux_modulos_en_negociacion += parseInt(entidad.pivot.cantidad_de_modulos)
              // this.aux_modulos_en_negociacion++
            }
          })
          element.cantidad_de_entidades_tecnicas = new Intl.NumberFormat().format(element.entidades_tecnicas.length)
          element.cantidad_de_modulos_registrados = new Intl.NumberFormat().format(this.cantidad_de_modulos_aux)
          element.cantidad_de_modulos_ganados = new Intl.NumberFormat().format(this.aux_modulos_ganados)
          element.porcentaje_cantidad_de_modulos_participados = (this.aux_modulos_en_negociacion / parseInt(element.cantidad_de_modulos_licitados)) ? Math.round((this.aux_modulos_en_negociacion / parseInt(element.cantidad_de_modulos_licitados)) * 10000) / 100 + '%' : '0%'
          element.porcentaje_cantidad_de_modulos_eficacia = (this.aux_entidades_ganadas / (this.aux_entidades_ganadas + this.aux_entidades_perdidas)) ? Math.round((this.aux_entidades_ganadas / (this.aux_entidades_ganadas + this.aux_entidades_perdidas)) * 10000) / 100 + '%' : '0%'
          element.cantidad_de_modulos_licitados = new Intl.NumberFormat().format(element.cantidad_de_modulos_licitados)
          //element.updated_at = new Intl.DateTimeFormat().format(element.updated_at)
          const updatedAt = {
            ...element, 
            updated_at: moment(element.updated_at).format('YYYY-MM-DD HH:mm:ss'), 
          }
          this.convocatorias.push(updatedAt)
          console.log(this.convocatorias)
        })
        //this.convocatorias = data.data
        //console.log(this.convocatorias)

        this.loading = false

        // await this.getEntidadesTecnicas()
      },
      dialogDelete (item) {
        this.$refs.dialogEntidades.open('Eliminar entidad convocatoria', '¿Esta seguro de eliminar esta convocatoria?', item)
      },
      onDialog (data) {
        this.eliminarConvoactoria(data)
      },
      async eliminarConvoactoria (convocatoria) {
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/convocatoria/' + convocatoria.id, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          }
        })
        const data = await response.json()
        if (data.success) {
          this.$refs.dialogEntidades.close()
          this.getConvocatorias()
        }
      },
      editarConvocatoria (item) {
        this.$refs.newConvocatoria.open(item)
      },
      agregarPorExcel () {
        this.$refs.agregarPorExcel.open()
      },
      onUploadExcel () {
      this.getConvocatorias()
      },
      verEntidades (item) {
        this.$router.push({ name: 'Entidades de una convocatoria', params: { convocatoria: item } })
        // this.$router.push({ name: 'Entidades de una convocatoria', params: { convocatoria: item } })
      },
      // async getEntidadesTecnicas () {
      //   this.datosDeEntidades = []
      //   if (this.tieneConvocatorias) {
      //     for (let i = 0; i < this.convocatorias.length; i++) {
      //       this.auxiliarModulos = 0
      //       this.auxliliarEntidadesTecnicas = 0
      //       this.datosDeEntidades = []
      //       this.auxiliarModulosGanados = []
      //       this.cantidadModulosGanados = 0

      //       await db.collection('EntidadesTecnicas').where('convocatorias', 'array-contains', this.convocatorias[i].nombre).get().then(entidades => {
      //         entidades.forEach(proyecto => {
      //         //suma de modulos y entidades tecnicas')
      //         this.datosDeEntidades.push(proyecto.data())
      //         const indice = proyecto.data().convocatorias.indexOf(this.convocatorias[i].nombre)
      //           this.auxiliarModulos = this.auxiliarModulos + proyecto.data().cantidadDeModulos[indice]
      //         })
      //       })

      //       await db.collection('Negocicion')
      //             .where('estadoDeNegociacion', '==', 'GANADO')
      //             .get()
      //             .then(negociaciones => {
      //         negociaciones.forEach(negociacion => {
      //         this.auxiliarModulosGanados.push(negociacion.data())
      //         })
      //       })

      //       for (let j = 0; j < this.auxiliarModulosGanados.length; j++) {
      //         for (let k = 0; k < this.datosDeEntidades.length; k++) {
      //           if (this.auxiliarModulosGanados[j].id === this.datosDeEntidades[k].id + this.convocatorias[i].id) {
      //             this.cantidadModulosGanados = this.cantidadModulosGanados + 1
      //           }
      //         }
      //       }

      //       await db.collection('Negocicion')
      //             .where('estadoDeNegociacion', '==', 'PERDIDO')
      //             .get()
      //             .then(negociaciones => {
      //         negociaciones.forEach(negociacion => {
      //         this.auxiliarModulosPerdidos.push(negociacion.data())
      //         })
      //       })

      //       for (let j = 0; j < this.auxiliarModulosPerdidos.length; j++) {
      //         for (let k = 0; k < this.datosDeEntidades.length; k++) {
      //           if (this.auxiliarModulosPerdidos[j].id === this.datosDeEntidades[k].id + this.convocatorias[i].id) {
      //             this.cantidadModulosPerdidos = this.cantidadModulosPerdidos + 1
      //           }
      //         }
      //       }

      //       const payload = {
      //           id: this.convocatorias[i].id,
      //           estado: this.convocatorias[i].estado,
      //           nombre: this.convocatorias[i].nombre,
      //           cantidadDeModulos: this.auxiliarModulos,
      //           cantidadDeModulosLicitados: this.convocatorias[i].cantidadDeModulosLicitados,
      //           cantidadDeEntidadesTecnicas: this.datosDeEntidades.length,
      //           cantidadDeModulosGanados: this.cantidadModulosGanados,
      //           cantidadDeModulosParticipante: this.cantidadModulosGanados / this.convocatorias[i].cantidadDeModulosLicitados ? (this.cantidadModulosGanados / this.convocatorias[i].cantidadDeModulosLicitados) * 100 + '%' : 0 * 100 + '%',
      //           cantidadDeModulosEficacia: (this.cantidadModulosGanados / (this.cantidadModulosGanados + this.cantidadModulosPerdidos)) ? (this.cantidadModulosGanados / (this.cantidadModulosGanados + this.cantidadModulosPerdidos)) * 100 + '%' : 0 * 100 + '%',
      //         }
      //       await this.convocatoriaCalculadas.push(payload)
      //     }
      //       this.loading = false
      //   } else {
      //   }
      // },
      exportarExcel () {
        this.isLoadingDownload = true
        const data = [
          {
            sheet: 'Campañas',
            columns: [
              { label: 'Nombre', value: 'nombre' },
              { label: 'Cantidad de entidades tecnicas', value: 'cantidad_de_entidades_tecnicas' },
              { label: 'Cant.MD. Registrado', value: 'cantidad_de_modulos_registrados' },
              { label: 'Cant.MD. Licitado', value: 'cantidad_de_modulos_licitados' },
              { label: 'Cant.MD. Ganados', value: 'cantidad_de_modulos_ganados' },
              { label: 'Cant.MD. partic %', value: 'porcentaje_cantidad_de_modulos_eficacia' },
              { label: 'Cant.MD. Eficacia %', value: 'porcentaje_cantidad_de_modulos_participados' },
              { label: 'Estado', value: 'estado' },
              // { label: 'EMAIL', value: '' }
            ],
            content: [
              ...this.convocatorias
            ]
          }]

        const settings = {
          sheetName: 'Data',
          fileName: 'Convocatorias'
        }

        xlsx(data, settings)
        this.isLoadingDownload = false
      }
    },
  }
</script>
